// Lightweight per-user UI preferences kept in localStorage. Emits a
// `nyx-prefs` event so live views can react without a store.

const PREVIEW_KEY = "nyx.prefs.v1.preview";

export type PreviewMode = "live" | "last" | "off";

export function getPreviewMode(): PreviewMode {
  const v = localStorage.getItem(PREVIEW_KEY);
  return v === "live" || v === "last" || v === "off" ? v : "live";
}

export function setPreviewMode(mode: PreviewMode): void {
  localStorage.setItem(PREVIEW_KEY, mode);
  window.dispatchEvent(new CustomEvent("nyx-prefs"));
}

/// Above this many running sessions, force the cheap "last" snapshot even in
/// live mode, so the dashboard never opens dozens of live sockets at once.
export const LIVE_PREVIEW_CAP = 8;
